<template>
  <a
    class="generic-search-list-card"
    :disabled="isLoading"
    :href="item.urlPath"
    :target="item.urlTarget"
    @click="openItemPage($event)"
  >
    <span
      class="generic-name"
      v-html="parsedItemLabel ? parsedItemLabel : item.label"
    />
    <span
      class="country-name"
      v-html="
        parsedItemDescription ? parsedItemDescription : item.shortDescription
      "
    />
    <span
      v-if="isSelecting"
      class="icon-loading-black"
    />
  </a>
</template>

<script>
  import { highlightMatch } from '@utils/highlight-match'
  import { mapState } from 'vuex'

  export default {
    name: 'GenericListCard',
    props: {
      item: {
        type: Object,
      },
      searchInput: {
        type: String,
        default: '',
      },
      queryChanged: {
        type: Number,
        default: -1,
      },
      isLoading: Boolean,
    },
    data: () => ({
      searchString: '',
      isSelecting: false,
    }),
    computed: {
      ...mapState('global', { currentLanguage: 'lang' }),
      parsedItemLabel: {
        get() {
          return highlightMatch(
            this.searchString,
            this.item.label,
            'bold-highlighted'
          )
        },
        set(newValue) {
          this.searchString = newValue
        },
      },
      parsedItemDescription: {
        get() {
          return highlightMatch(
            this.searchString,
            this.item.shortDescription,
            'bold-highlighted'
          )
        },
        set(newValue) {
          this.searchString = newValue
        },
      },
    },
    watch: {
      searchInput(val) {
        if (val) {
          this.searchString = val
        } else {
          this.searchString = ''
        }
      },
      queryChanged() {
        this.searchString = this.searchInput
      },
    },
    methods: {
      openItemPage(e) {
        if (this.item.urlTarget.startsWith('external:')) {
          this.$root.$refs.externalLinkModal.onClick(e)
        }
      },
    },
  }
</script>
